<template>
	<v-container>
		<info-display
			v-for="(item, index) in infoDisplay"
      :key="`info_panel-${index}`"
			:color=" (index%2)==0?'siiPrimary': 'siiNaranjo'"
			:inverseOrder="(index%2)==1"
			dark
		>
			<template v-slot:prepend>
				<v-icon v-if=" item.hasOwnProperty('icon') ">{{item.icon}}</v-icon>
			</template>
			<template v-slot:body>
				{{ item.text }}
			</template>
		</info-display>
	</v-container>
</template>

<script>

import InfoDisplay from '@/components/InfoDisplay';

export default {
  name: 'InfoPanel',
  components:{
  	InfoDisplay
  },
  computed:{
  	infoDisplay(){
  		return [
  			{
  				icon: 'receipt',
  				text: this.$t('login.info.funcion')
  			},
  			{
  				icon: 'attach_email',
  				text: this.$t('login.info.internet')
  			},
  			{
  				icon: 'security',
  				text: this.$t('login.info.seguridad')
  			},
  		]
  	}
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>